import {useEffect, useRef, useState} from "react";
import {Axios} from "api";
import {productScrapContextRef} from "context/ProductScrapContext";
import LoadingSearchResult, {SearchResultError} from "components/sections/search/LoadingSearchResult";
import {captureException, captureMessage} from "@sentry/nextjs";
import {useRouter} from "next/router";
import {
    STORE_SEARCH_FILTER_TYPE_NAME_ONLY,
    STORE_SEARCH_FILTER_TYPE_SPECIAL_PRICE
} from "components/sections/search/store/StoreSearchFilter";
import {OverallStoreSection} from "components/sections/search/store/OverallStoreSection";
import styles from "components/sections/search/store/StoreSearchResultFirst.module.scss";

const StoreSearchResultFirst = () => {
    const router = useRouter();

    const [error, setError] = useState(false);

    const [overallResult, setOverallResult] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const currentQueryRef = useRef(null);

    useEffect(() => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            'ViewStoreSearchResultFirstPhase',
        );
    }, []);

    const getQueryFilterInfo = (queryInfo) => {
        const query = queryInfo?.q || '';
        console.log('getQueryFilterInfo', queryInfo, query);
        const sortOrder = queryInfo.order;
        const isNameOnly = queryInfo[STORE_SEARCH_FILTER_TYPE_NAME_ONLY] === 'true';
        const isSpecialPriceOnly = queryInfo[STORE_SEARCH_FILTER_TYPE_SPECIAL_PRICE] === 'true';
        const categoryIds = queryInfo.categories ? queryInfo.categories.split(',').map(x => parseInt(x) || null).filter(x => x !== null) : [];
        const brandIds = queryInfo.brands ? queryInfo.brands.split(',').map(x => parseInt(x)).filter(x => x !== null) : [];
        return {
            query,
            sortOrder,
            isNameOnly,
            isSpecialPriceOnly,
            categoryIds,
            brandIds
        };
    };

    const fetchProducts = async () => {
        try {
            setError(false);
            setIsLoading(true);
            const {query} = getQueryFilterInfo(router.query);
            currentQueryRef.current = query;

            const res = await Axios.post(
                `v1/search/store/overall`,
                {
                    query,
                }
            );
            if (currentQueryRef.current !== query) {
                return;
            }
            if (res.status < 400) {
                console.log('fetchProducts res', res);
                setOverallResult(res.data);
                console.log('overallStoreResult', res.data);
                if (res.data.scrapped_product_ids) {
                    productScrapContextRef.current.addProductIds(res.data.scrapped_product_ids);
                }
            } else {
                captureMessage(JSON.stringify(res.data));
                setError(true);
            }
            setIsLoading(false);
        } catch (e) {
            console.log('fetchProducts error', e);
            setError(true);
            setIsLoading(false);
            captureException(e);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, [router.query.q]);

    // const isSearchRequested = Boolean(router.query.q) || Boolean(router.query.categories) || Boolean(router.query.brands);

    return (
        <div className={styles.container}>
            {
                error
                    ? <SearchResultError handleRefresh={fetchProducts}/>
                    :
                    (isLoading
                            ? <LoadingSearchResult/>
                            : overallResult ? <OverallStoreSection
                                overallStoreResult={overallResult.overall_store_search_result}
                                query={router.query.q}
                            /> : <div />
                    )
            }
        </div>
    );

}

export default StoreSearchResultFirst;
